import { render } from "./tablemasterp2h.vue?vue&type=template&id=150679f1"
import script from "./tablemasterp2h.vue?vue&type=script&lang=js"
export * from "./tablemasterp2h.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__